import objectFitImages from 'object-fit-images'
import UI from '/javascripts/utils/UI'
import bus from '/javascripts/bus'

UI({
  component: '.js-pageHeader',
  images: ['.js-pageHeader-image'],
  staggerItems: ['.js-pageHeader-staggerItem']
}, ({ component, images, staggerItems }) => {
  bus.on('onUpdateScrollFromTop', updateElements)

  if (images.length > 0) {
    staggerItems.forEach(image => objectFitImages(image))
  }

  function updateElements({ progress }) {
    const positionOffset = Math.floor(component.clientHeight * (progress / 3))
    const numberOfElements = staggerItems.length

    staggerItems.forEach((element, index) => {
      const position = index + 1
      const elementOffset = Math.floor(positionOffset / numberOfElements * position)
      const opacity = 1 - ((progress * 4) / numberOfElements * position)

      element.style.opacity = opacity > 0 ? opacity : 0
      element.style.transform = `translateY(-${elementOffset}px)`
    })
  }
})
